import store from '@insight/store/index';
import router from '@insight/router/index';

export default {
    store,
    router
};
